<template>
    <div>
        <el-button type="text" @click="addNode">添加签单模式</el-button>
        &nbsp;&nbsp;&nbsp;
        <el-tooltip v-if="tooltip_content" class="item" effect="dark" :content="tooltip_content" placement="top">
            <i class="el-icon-info"></i>
        </el-tooltip>
        <el-table width="100%" :data="list" :show-header="false" v-if="list.length > 0">
            <el-table-column prop="sign_mode" width="190">
                <template slot-scope="scope">
                    签单模式
                    <el-select v-model="scope.row.sign_mode" size="mini" placeholder="请选择" style="width:110px;">
                        <el-option label="普通订单" value="0"></el-option>
                        <el-option label="代理自签单" value="1"></el-option>
                        <el-option label="代理代签单" value="2"></el-option>
                        <el-option label="经销订单" value="3"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="time_field" width="470">
                <template slot-scope="scope">
                    <div style="text-align: left;">
                        时间
                        <el-select v-model="scope.row.time_field" size="mini" placeholder="请选择" style="width:120px;">
                            <el-option label="录单时间" value="create"></el-option>
                            <el-option label="合同上传时间" value="contract"></el-option>
                            <el-option label="实际回款时间" value="payment"></el-option>
                        </el-select>
                        =
                        <el-select v-model="scope.row.time_type" size="mini" placeholder="请选择" style="width:90px;">
                            <el-option label="整月" value="0"></el-option>
                            <el-option label="自定义" value="1"></el-option>
                        </el-select>
                        <el-date-picker
                        v-if="scope.row.time_type == 1"
                        size="mini"
                        type="daterange"
                        v-model="scope.row.times"
                        format="dd"
                        value-format="dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        style="width:180px;">
                        </el-date-picker>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="50">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteNode(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import UserSelect from "~/widgets/UserSelect.vue";
    export default{
        components: {UserSelect},
        props: {
            nodes: {
                type: Array,
                required: true
            },

            tooltip_content: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                check_rule_temporary:1,
                check_rule_permanent:2,
                check_rule_default:0,
                radio:'',
                list: [],
                pickerOptions: {
                    disabledDate(time) {
                        // 获取日期的日部分
                        const day = time.getDate();
                        // 如果日期是29、30或31，就禁用这个日期
                        console.log(time, day);
                        return day >= 29;
                    },
                
                },
            }
        },

        watch: {
            list: {
                handler(newVal, oldVal) {
                    // 当 list 或其内部对象的值发生变化时，这个函数将被调用
                    // console.log('list changed:', newVal);
                    // 你可以在这里执行需要的逻辑
                    this.$emit("change", newVal);
                },
                deep: true // 深度监听，用于监听内部对象变化
            }
        },

        created() {
            this.list = this.nodes;
        },
        methods:{
            /**
             * 删除节点
             * @param id
             */
            deleteNode(id){
                this.list = this.list.filter(function (item) {
                    return item.id != id;
                });
            },

            /**
             * 添加节点
             * @param id
             */
             addNode(){
                this.list.push(
                    {
                        id: this.list.length + 1,
                        sign_mode: '0',
                        time_field: 'create',
                        time_type: '0',
                        times: []
                    }
                )
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/widgets/table/CountConfigNode.vue